import { Close, ExpandLess, ExpandMore } from "@mui/icons-material";
import MenuIcon from "@mui/icons-material/Menu";
import {
    Box,
    Collapse,
    List,
    ListItemButton,
    ListItemText,
    Stack,
    Typography
} from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import {
    MuiIconButton,
    MuiStack
} from "../components";
import { setIsLeftMenuOpen } from "../redux/commonSlice";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { appBarColor, drawerColor, drawerWidth, identityRoutes } from "./drawerComponent.entity";
import Header from "./headerComponent";
import { useLocation } from "react-router-dom";
import { ResponseArray } from "./common.entity";


interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
    transition: theme.transitions.create(["margin", "width"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),

    ...(open && {
        transition: theme.transitions.create(["margin", "width"], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled(Stack)(({ theme }) => ({
    padding: '8px 16px',
    paddingRight: '8px',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
}));

const defaultPanelId = 2;

const findPanelByPath = (routes: ResponseArray, path: string) => {
    let id: number = NaN;
    routes?.forEach(item => {
        if (item?.subNav?.length > 0) id = findPanelByPath(item?.subNav, path);
        else {
            const matched = path.split('/').includes(item.path.split('/')[1]);
            if (matched) id = item.id;
        }
    })
    return id;
}

export default function LeftDrawer() {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const location = useLocation();
    const [openCollapse, setOpenCollapse] = useState(true);
    const [selectedPanel, setSelectedPanel] = useState(defaultPanelId);

    const { isMenuOpen } = useAppSelector((state: any) => state.common)

    useEffect(() => {
        setSelectedPanel(findPanelByPath(identityRoutes, location.pathname));
    }, [])

    const handleDrawerSlide = () => {
        dispatch(setIsLeftMenuOpen(!isMenuOpen));
    };

    const handleClick = (item: any) => {
        if (item?.id) setSelectedPanel(item?.id);
        if (item?.subNav?.length > 0) {
            setOpenCollapse(!openCollapse);
        } else {
            navigate(`${item?.path}`);
        }
    };

    return (
        <Box bgcolor='white' >
            <AppBar
                elevation={0}
                position="fixed"
                sx={{
                    background: appBarColor,
                    boxShadow: "0px 2px 5px 0 rgba(100, 100, 100, 0.1), 0px 0px 5px 0 #f5f5f5",
                    borderBottom: '1px solid rgba(0,0,0, 0.05)'
                }}
            >
                <Stack
                    flexDirection={'row'}
                    alignItems='center'
                    justifyContent='space-between'
                    px={1} py={1}
                >
                    <IconButton
                        color="primary"
                        aria-label="open drawer"
                        onClick={handleDrawerSlide}
                        edge="start"
                        sx={{ ml: 1, height: 'fit-content' }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Header />
                </Stack>
            </AppBar>

            <Drawer
                PaperProps={{
                    sx: {
                        width: drawerWidth,
                        boxSizing: "border-box",
                        backgroundColor: drawerColor,
                    },
                    elevation: 3
                }}
                variant="persistent"
                anchor="left"
                open={isMenuOpen}

            >
                <DrawerHeader>
                    <Typography variant="h2">Identity</Typography>
                    <IconButton
                        color="primary"
                        aria-label="close drawer"
                        onClick={handleDrawerSlide}
                        edge="end"
                        sx={{ mr: 0, height: 'fit-content' }}
                    >
                        <Close />
                    </IconButton>
                </DrawerHeader>

                <List
                    sx={{
                        width: "100%",
                        maxWidth: 360,
                        position: "relative",
                        overflow: "auto",
                        maxHeight: "90vh",
                        scrollbarWidth: "none", // For Firefox
                        msOverflowStyle: "none", // For Internet Explorer and Edge
                    }}
                    disablePadding
                >
                    {identityRoutes?.map((item: any, index: any) => (

                        <ListItemButton
                            key={item?.id}
                            onClick={() => handleClick(item)}
                            selected={Boolean(item.id === selectedPanel)}
                        >
                            <ListItemText
                                key={index}
                                primary={item.text}
                                primaryTypographyProps={{ letterSpacing: 0.5 }}
                            />
                        </ListItemButton>
                    ))}
                </List>
            </Drawer>
        </Box>
    );
}
